import useSearchLabel from "~/features/SearchV3/hooks/useSearchLabel";
import { useHelperStore } from "~/stores";

import LoadingSpinner from "~/ui/LoadingSpinner/LoadingSpinner";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import useSearchDialogForm from "../../hooks/useSearchDialogForm";

const BtnPopupTrigger = () => {
    const { textLabel } = useSearchLabel();
    const isFetching = useHelperStore(state => state.isLoading);
    const isAppInitialized = useHelperStore(state => state.isAppInitialized);
    const { handleSetShowDialog } = useSearchDialogForm();
    const isLocked = isFetching || !isAppInitialized;

    const iconDisplay = isLocked ? (
        <LoadingSpinner />
    ) : (
        <ChevronDownIcon className="w-4 h-4 text-stone-darkest" />
    );

    return (
        <button
            onClick={() => handleSetShowDialog()}
            className="flex flex-1 justify-between items-center outline-none"
            disabled={isLocked}
        >
            {textLabel}
            {iconDisplay}
        </button>
    );
};

export default BtnPopupTrigger;
